<template>
  <div>
    <div v-if="Object.keys(user).length === 0">加载中...</div>
    <div v-else>
      <vue-editor
        useCustomImageHandler
        @image-added="handleImageAdded"
        v-model="body"
        :editor-options="editorOptions"
        :editor-toolbar="editorToolbar"
        :required="true"
      >
      </vue-editor>

      <div>
        除了黄赌毒之外，其他都可以放在这，包括你的联系方式，宣传图片等。
      </div>
      <div style="text-align:right; clear: both">
        <el-button
          native-type="button"
          @click="postProfile"
          icon="el-icon-check"
          :disabled="!user.subscribed"
        >
          更新（会员专享）
        </el-button>
        <p v-if="!user.subscribed">
          会员专享功能， <a href="/user/subscription">点击购买会员。</a>
        </p>
      </div>
    </div>
    <br />

    <div>
      <div>
        <el-switch
          v-model="showPreview"
          active-text="显示预览"
          inactive-text="隐藏预览"
        >
        </el-switch>
        &nbsp;&nbsp;
        <a :href="'/users/' + user.id + '/profile'" target="_blank">
          前往我的主页
          <font-awesome-icon icon="external-link-alt" />
        </a>
      </div>
      <br />
      <div v-if="showPreview">
        预览
        <user-profile-page-preview
          :key="userKey"
          :body="body"
        ></user-profile-page-preview>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import UserProfilePagePreview from "@/components/UserProfilePagePreview";

export default {
  computed: {
    ...mapState(["user", "token"]),
    actionUrl: function() {
      return process.env.VUE_APP_API_BASE_URL + "/images/";
    }
  },
  data: function() {
    return {
      editorOptions: {
        modules: {
          imageResize: {}
        }
      },
      editorToolbar: [
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [({ indent: "-1" }, { indent: "+1" })],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
        ["clean"]
      ],
      body: "",
      userKey: Math.random(),
      showPreview: true
    };
  },
  components: {
    UserProfilePagePreview
  },
  watch: {
    body: function() {
      this.userKey = Math.random();
    }
  },
  // set the layout to user when it's mounted.
  mounted: function() {
    this.fetchProfile();
  },
  methods: {
    ...mapMutations(["setLoading"]),
    fetchProfile: function() {
      var self = this;
      this.setLoading(true);
      this.$http
        .get("/user/profile")
        .then(response => {
          self.body = response.data.body;
          self.setLoading(false);
        })
        .catch(function() {
          self.setLoading(false);
        });
    },
    postProfile: function() {
      var self = this;
      this.setLoading(true);
      this.$http
        .post("/user/profile", { body: self.body })
        .then(() => {
          self.$message({
            message: "主页更新成功",
            type: "success"
          });
          self.userKey = Math.random();
          self.setLoading(false);
        })
        .catch(function() {
          self.setLoading(false);
        });
    },
    // wysiwyg related
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      // An example of using FormData
      // NOTE: Your key could be different such as:
      // formData.append('file', file)

      var formData = new FormData();
      formData.append("image", file);
      formData.append("type", "profile");
      this.$http({
        url: "/images",
        method: "POST",
        data: formData
      }).then(response => {
        let url = response.data.path; // Get url from response
        Editor.insertEmbed(cursorLocation, "image", url);
        resetUploader();
      });
    }
  }
};
</script>
<style></style>
